import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Display/Tooltip/Tooltip';

type UsageMetricProps = {
  label: string;
  value: number;
  tooltip?: string;
};

export const UsageMetric = ({ label, value, tooltip }: UsageMetricProps) => (
  <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-3">
    <div className="flex items-center gap-1">
      <span className="text-sm font-medium text-gray-900">{label}</span>
      {tooltip && (
        <Tooltip>
          <TooltipTrigger>
            <InformationCircleIcon className="size-4 text-gray-400 hover:text-procuros-green-500" />
          </TooltipTrigger>
          <TooltipContent>{tooltip}</TooltipContent>
        </Tooltip>
      )}
    </div>
    <span className="text-2xl font-bold text-gray-900">{value.toLocaleString()}</span>
  </div>
);
